module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('div', {
    staticClass: "mdl-grid demo-content"
  }, [_c('div', {
    staticClass: "demo-charts mdl-color--white mdl-shadow--2dp mdl-cell mdl-cell--12-col mdl-grid"
  }, [_c('svg', {
    staticClass: "demo-chart mdl-cell mdl-cell--4-col mdl-cell--3-col-desktop",
    attrs: {
      "fill": "currentColor",
      "width": "200px",
      "height": "200px",
      "viewBox": "0 0 1 1"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#piechart",
      "mask": "url(#piemask)"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "0.5",
      "y": "0.5",
      "font-family": "Roboto",
      "font-size": "0.3",
      "fill": "#888",
      "text-anchor": "middle",
      "dy": "0.1"
    }
  }, [_vm._v("82"), _c('tspan', {
    attrs: {
      "font-size": "0.2",
      "dy": "-0.07"
    }
  }, [_vm._v("%")])])]), _vm._v(" "), _c('svg', {
    staticClass: "demo-chart mdl-cell mdl-cell--4-col mdl-cell--3-col-desktop",
    attrs: {
      "fill": "currentColor",
      "width": "200px",
      "height": "200px",
      "viewBox": "0 0 1 1"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#piechart",
      "mask": "url(#piemask)"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "0.5",
      "y": "0.5",
      "font-family": "Roboto",
      "font-size": "0.3",
      "fill": "#888",
      "text-anchor": "middle",
      "dy": "0.1"
    }
  }, [_vm._v("82"), _c('tspan', {
    attrs: {
      "dy": "-0.07",
      "font-size": "0.2"
    }
  }, [_vm._v("%")])])]), _vm._v(" "), _c('svg', {
    staticClass: "demo-chart mdl-cell mdl-cell--4-col mdl-cell--3-col-desktop",
    attrs: {
      "fill": "currentColor",
      "width": "200px",
      "height": "200px",
      "viewBox": "0 0 1 1"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#piechart",
      "mask": "url(#piemask)"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "0.5",
      "y": "0.5",
      "font-family": "Roboto",
      "font-size": "0.3",
      "fill": "#888",
      "text-anchor": "middle",
      "dy": "0.1"
    }
  }, [_vm._v("82"), _c('tspan', {
    attrs: {
      "dy": "-0.07",
      "font-size": "0.2"
    }
  }, [_vm._v("%")])])]), _vm._v(" "), _c('svg', {
    staticClass: "demo-chart mdl-cell mdl-cell--4-col mdl-cell--3-col-desktop",
    attrs: {
      "fill": "currentColor",
      "width": "200px",
      "height": "200px",
      "viewBox": "0 0 1 1"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#piechart",
      "mask": "url(#piemask)"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "0.5",
      "y": "0.5",
      "font-family": "Roboto",
      "font-size": "0.3",
      "fill": "#888",
      "text-anchor": "middle",
      "dy": "0.1"
    }
  }, [_vm._v("82"), _c('tspan', {
    attrs: {
      "dy": "-0.07",
      "font-size": "0.2"
    }
  }, [_vm._v("%")])])])]), _vm._v(" "), _c('div', {
    staticClass: "demo-graphs mdl-shadow--2dp mdl-color--white mdl-cell mdl-cell--8-col"
  }, [_c('svg', {
    staticClass: "demo-graph",
    attrs: {
      "fill": "currentColor",
      "viewBox": "0 0 500 250"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#chart"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "demo-graph",
    attrs: {
      "fill": "currentColor",
      "viewBox": "0 0 500 250"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#chart"
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('svg', {
    staticStyle: {
      "position": "fixed",
      "left": "-1000px",
      "height": "-1000px"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1"
    }
  }, [_c('defs', [_c('mask', {
    attrs: {
      "id": "piemask",
      "maskContentUnits": "objectBoundingBox"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "0.5",
      "cy": "0.5",
      "r": "0.49",
      "fill": "white"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "0.5",
      "cy": "0.5",
      "r": "0.40",
      "fill": "black"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "piechart"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "0.5",
      "cy": "0.5",
      "r": "0.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M 0.5 0.5 0.5 0 A 0.5 0.5 0 0 1 0.95 0.28 z",
      "stroke": "none",
      "fill": "rgba(255, 255, 255, 0.75)"
    }
  })])])]), _vm._v(" "), _c('svg', {
    staticStyle: {
      "position": "fixed",
      "left": "-1000px",
      "height": "-1000px"
    },
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "viewBox": "0 0 500 250"
    }
  }, [_c('defs', [_c('g', {
    attrs: {
      "id": "chart"
    }
  }, [_c('g', {
    attrs: {
      "id": "Gridlines"
    }
  }, [_c('line', {
    attrs: {
      "fill": "#888888",
      "stroke": "#888888",
      "stroke-miterlimit": "10",
      "x1": "0",
      "y1": "27.3",
      "x2": "468.3",
      "y2": "27.3"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "fill": "#888888",
      "stroke": "#888888",
      "stroke-miterlimit": "10",
      "x1": "0",
      "y1": "66.7",
      "x2": "468.3",
      "y2": "66.7"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "fill": "#888888",
      "stroke": "#888888",
      "stroke-miterlimit": "10",
      "x1": "0",
      "y1": "105.3",
      "x2": "468.3",
      "y2": "105.3"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "fill": "#888888",
      "stroke": "#888888",
      "stroke-miterlimit": "10",
      "x1": "0",
      "y1": "144.7",
      "x2": "468.3",
      "y2": "144.7"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "fill": "#888888",
      "stroke": "#888888",
      "stroke-miterlimit": "10",
      "x1": "0",
      "y1": "184.3",
      "x2": "468.3",
      "y2": "184.3"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Numbers"
    }
  }, [_c('text', {
    attrs: {
      "transform": "matrix(1 0 0 1 485 29.3333)",
      "fill": "#888888",
      "font-family": "'Roboto'",
      "font-size": "9"
    }
  }, [_vm._v("500")]), _vm._v(" "), _c('text', {
    attrs: {
      "transform": "matrix(1 0 0 1 485 69)",
      "fill": "#888888",
      "font-family": "'Roboto'",
      "font-size": "9"
    }
  }, [_vm._v("400")]), _vm._v(" "), _c('text', {
    attrs: {
      "transform": "matrix(1 0 0 1 485 109.3333)",
      "fill": "#888888",
      "font-family": "'Roboto'",
      "font-size": "9"
    }
  }, [_vm._v("300")]), _vm._v(" "), _c('text', {
    attrs: {
      "transform": "matrix(1 0 0 1 485 149)",
      "fill": "#888888",
      "font-family": "'Roboto'",
      "font-size": "9"
    }
  }, [_vm._v("200")]), _vm._v(" "), _c('text', {
    attrs: {
      "transform": "matrix(1 0 0 1 485 188.3333)",
      "fill": "#888888",
      "font-family": "'Roboto'",
      "font-size": "9"
    }
  }, [_vm._v("100")]), _vm._v(" "), _c('text', {
    attrs: {
      "transform": "matrix(1 0 0 1 0 249.0003)",
      "fill": "#888888",
      "font-family": "'Roboto'",
      "font-size": "9"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('text', {
    attrs: {
      "transform": "matrix(1 0 0 1 78 249.0003)",
      "fill": "#888888",
      "font-family": "'Roboto'",
      "font-size": "9"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('text', {
    attrs: {
      "transform": "matrix(1 0 0 1 154.6667 249.0003)",
      "fill": "#888888",
      "font-family": "'Roboto'",
      "font-size": "9"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('text', {
    attrs: {
      "transform": "matrix(1 0 0 1 232.1667 249.0003)",
      "fill": "#888888",
      "font-family": "'Roboto'",
      "font-size": "9"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('text', {
    attrs: {
      "transform": "matrix(1 0 0 1 309 249.0003)",
      "fill": "#888888",
      "font-family": "'Roboto'",
      "font-size": "9"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('text', {
    attrs: {
      "transform": "matrix(1 0 0 1 386.6667 249.0003)",
      "fill": "#888888",
      "font-family": "'Roboto'",
      "font-size": "9"
    }
  }, [_vm._v("6")]), _vm._v(" "), _c('text', {
    attrs: {
      "transform": "matrix(1 0 0 1 464.3333 249.0003)",
      "fill": "#888888",
      "font-family": "'Roboto'",
      "font-size": "9"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Layer_5"
    }
  }, [_c('polygon', {
    attrs: {
      "opacity": "0.36",
      "stroke-miterlimit": "10",
      "points": "0,223.3 48,138.5 154.7,169 211,88.5\n            294.5,80.5 380,165.2 437,75.5 469.5,223.3 \t"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Layer_4"
    }
  }, [_c('polygon', {
    attrs: {
      "stroke-miterlimit": "10",
      "points": "469.3,222.7 1,222.7 48.7,166.7 155.7,188.3 212,132.7\n            296.7,128 380.7,184.3 436.7,125 \t"
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo-cards mdl-cell mdl-cell--4-col mdl-cell--8-col-tablet mdl-grid mdl-grid--no-spacing"
  }, [_c('div', {
    staticClass: "demo-updates mdl-card mdl-shadow--2dp mdl-cell mdl-cell--4-col mdl-cell--4-col-tablet mdl-cell--12-col-desktop"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-card--expand mdl-color--teal-300"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v("Updates")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-color-text--grey-600"
  }, [_vm._v("\n          Non dolore elit adipisicing ea reprehenderit consectetur culpa.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__actions mdl-card--border"
  }, [_c('a', {
    staticClass: "mdl-button mdl-js-button mdl-js-ripple-effect",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Read More")])])]), _vm._v(" "), _c('div', {
    staticClass: "demo-separator mdl-cell--1-col"
  }), _vm._v(" "), _c('div', {
    staticClass: "demo-options mdl-card mdl-color--deep-purple-500 mdl-shadow--2dp mdl-cell mdl-cell--4-col mdl-cell--3-col-tablet mdl-cell--12-col-desktop"
  }, [_c('div', {
    staticClass: "mdl-card__supporting-text mdl-color-text--blue-grey-50"
  }, [_c('h3', [_vm._v("View options")]), _vm._v(" "), _c('ul', [_c('li', [_c('label', {
    staticClass: "mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect",
    attrs: {
      "for": "chkbox1"
    }
  }, [_c('input', {
    staticClass: "mdl-checkbox__input",
    attrs: {
      "type": "checkbox",
      "id": "chkbox1"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-checkbox__label"
  }, [_vm._v("Click per object")])])]), _vm._v(" "), _c('li', [_c('label', {
    staticClass: "mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect",
    attrs: {
      "for": "chkbox2"
    }
  }, [_c('input', {
    staticClass: "mdl-checkbox__input",
    attrs: {
      "type": "checkbox",
      "id": "chkbox2"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-checkbox__label"
  }, [_vm._v("Views per object")])])]), _vm._v(" "), _c('li', [_c('label', {
    staticClass: "mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect",
    attrs: {
      "for": "chkbox3"
    }
  }, [_c('input', {
    staticClass: "mdl-checkbox__input",
    attrs: {
      "type": "checkbox",
      "id": "chkbox3"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-checkbox__label"
  }, [_vm._v("Objects selected")])])]), _vm._v(" "), _c('li', [_c('label', {
    staticClass: "mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect",
    attrs: {
      "for": "chkbox4"
    }
  }, [_c('input', {
    staticClass: "mdl-checkbox__input",
    attrs: {
      "type": "checkbox",
      "id": "chkbox4"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-checkbox__label"
  }, [_vm._v("Objects viewed")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__actions mdl-card--border"
  }, [_c('a', {
    staticClass: "mdl-button mdl-js-button mdl-js-ripple-effect mdl-color-text--blue-grey-50",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Change location")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  }), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("location_on")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-87b09e2c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 463
// module chunks = 0